import { EventContextProvider } from "@codat/analytics";
import { SourceTypeResponse, SourceTypesQueryResponse } from "api/company";
import { SourceTypeStatus, useSourceTypes } from "contexts/SourceTypesContext";
import { useSourceTypeResolver } from "hooks/useSourceTypeResolver";

export interface WithSourceTypeInnerProps {
  sourceTypes: SourceTypesQueryResponse | undefined;
  sourceTypesStatus: SourceTypeStatus;
  currentSourceType: SourceTypeResponse | undefined;
  nextPrioritySourceType: SourceTypeResponse | undefined;
}

interface WithSourceTypeEventContextProps {
  sourceType?: string;
  eventName: (sourceType: string | undefined) => string;
  children: (props: WithSourceTypeInnerProps) => React.ReactNode;
}

/**
 * Component to wrap another component in an EventContextProvider with a name that
 *   depends on the sourceType
 * @param props
 * @returns
 */
export const WithSourceTypeEvent: React.FC<WithSourceTypeEventContextProps> = (
  props
) => {
  const { sourceType, eventName, children } = props;

  const { sourceTypes, status: sourceTypesStatus } = useSourceTypes();
  const { currentSourceType, nextPrioritySourceType } = useSourceTypeResolver(
    { sourceType },
    sourceTypes
  );

  const contextName = eventName(currentSourceType?.sourceType);

  return (
    <EventContextProvider name={contextName}>
      {children({
        sourceTypes,
        sourceTypesStatus,
        currentSourceType,
        nextPrioritySourceType,
      })}
    </EventContextProvider>
  );
};
